import type { PriceBasisInput } from './computePriceBasis';
import { getPriceCategory, type PriceCategory } from './getPriceCategory';
import { getPriceFinality } from './getPriceFinality';

function readStrategy(leg: PriceBasisInput): string | undefined {
  return leg.pricingStrategy ?? undefined;
}

/**
 * UI-facing price category combining **final state** (`priceBasis` /
 * {@link getPriceFinality}) with **origin** ({@link getPriceCategory}).
 *
 * When the leg is `manual` with a positive load price → `one_time`
 * (custom / not honoring a frozen quote). When `manual` with zero load
 * price and unresolved origin → `unresolved` (awaiting price). When
 * `route_quoted` → agreement / everyone from origin strategy.
 */
export function getDisplayPriceCategory(
  leg: PriceBasisInput | null | undefined,
): PriceCategory {
  if (leg == null) return 'unresolved';

  const finality = getPriceFinality(leg);
  const loadPrice = leg.amount?.itemsOriginalSubtotal ?? 0;
  const strategy = readStrategy(leg);

  if (finality === 'route_quoted') {
    return getPriceCategory(leg);
  }

  // manual final state
  if (
    loadPrice <= 0 &&
    (strategy === 'unresolved_pricing' ||
      strategy === 'distance_based_pricing' ||
      strategy === undefined)
  ) {
    return 'unresolved';
  }

  return 'one_time';
}
